import type {
  ManageMeetingPageName,
  PreClientPageName,
} from "./pre-client.types";

export const PRE_CLIENT_PATH = "/client";
export const INTAKE_WHAT_TO_EXPECT_URL = `${PRE_CLIENT_PATH}/intake/info/what-to-expect`;
export const INTAKE_RESCHEDULE_URL = `${PRE_CLIENT_PATH}/intake/reschedule-meeting/reschedule`;
export const INTAKE_RESCHEDULE_ERROR_URL = `${PRE_CLIENT_PATH}/intake/reschedule-meeting/error`;
export const INTAKE_SCHEDULE_ERROR_URL = `${PRE_CLIENT_PATH}/intake/schedule-meeting/error`;
export const INTAKE_CANCEL_URL = `${PRE_CLIENT_PATH}/intake/cancel-meeting/cancel`;
export const LSS_WHAT_TO_EXPECT_URL = `${PRE_CLIENT_PATH}/lss/info/what-to-expect`;
export const LSS_RESCHEDULE_URL = `${PRE_CLIENT_PATH}/lss/reschedule-meeting/reschedule`;
export const LSS_RESCHEDULE_ERROR_URL = `${PRE_CLIENT_PATH}/lss/reschedule-meeting/error`;
export const LSS_CANCEL_URL = `${PRE_CLIENT_PATH}/lss/cancel-meeting/cancel`;
export const PERSONAL_INFO_URL = `${PRE_CLIENT_PATH}/personal-info`;
export const OUR_ATTORNEYS_URL = `${PRE_CLIENT_PATH}/our-attorneys`;
export const PRICING_URL = `${PRE_CLIENT_PATH}/pricing`;
export const MARBLE_TECH_URL = `${PRE_CLIENT_PATH}/marble-tech`;
export const MARBLE_BLOG_URL = "https://marble.co/blog";
export const CALL_US_PHONE_NUMBER = "866228-5777";
export const CALL_US_PHONE_DISPLAY_NUMBER = "(866) 228-5777";
export const SIGNIN_PAGE_URL = "/signin";
export const LEGAL_PLAN_URL = `${PRE_CLIENT_PATH}/legal-plan`;

export const pathMap: Record<
  string,
  PreClientPageName | ManageMeetingPageName
> = {
  [PRE_CLIENT_PATH]: "welcome",
  [PERSONAL_INFO_URL]: "personal_info_page",
  [INTAKE_CANCEL_URL]: "cancel_call",
  [INTAKE_RESCHEDULE_URL]: "calendar_view",
  [INTAKE_RESCHEDULE_ERROR_URL]: "error",
  [INTAKE_WHAT_TO_EXPECT_URL]: "what_to_expect",
  [LSS_CANCEL_URL]: "cancel_call",
  [LSS_RESCHEDULE_URL]: "calendar_view",
  [LSS_RESCHEDULE_ERROR_URL]: "error",
  [LSS_WHAT_TO_EXPECT_URL]: "what_to_expect",
};

export const STEP_IMAGE_MAX_DIMENSIONS = {
  width: 792,
  height: 392.28,
} as const;
